'use strict';

import type { UserSoa } from '../../Entities/User/UserSoa';
import { EntityCollection } from '../EntityCollection';

export class UserSoaCollection extends EntityCollection<UserSoa> {}
